<app-header-notification
  type="warning"
  *ngIf="enabled && offline && !seen"
  (dismissClick)="handleHeaderDismissClick()">
  <div class="text-13 text-medium">You are offline. Check your data or wifi connection.</div>
</app-header-notification>
